// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2VP8y","buttons":"Footer_buttons__10ko9"};